import { render } from "./IqraStudentWeeklySchedule.vue?vue&type=template&id=151bd9da&scoped=true"
import script from "./IqraStudentWeeklySchedule.vue?vue&type=script&lang=js"
export * from "./IqraStudentWeeklySchedule.vue?vue&type=script&lang=js"

import "./IqraStudentWeeklySchedule.vue?vue&type=style&index=0&id=151bd9da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151bd9da"]])

export default __exports__